import type { IntlShape } from 'react-intl'
import { getRequiredFields } from 'util/getZodSchemaRequiredFields'
import type { z } from 'zod'
import { PurchaseInvoiceSchema } from '../validation'

export const FormSchema = PurchaseInvoiceSchema

export const requiredFormFields = getRequiredFields(FormSchema)

export type FormInputs = z.infer<typeof FormSchema>
export type CreateFormInputs = Omit<FormInputs, 'id' | 'databaseSource'>
// TODO: REMOVE
// eslint-disable-next-line unused-imports/no-unused-vars
export const createFormSchemaLocalized = (intl: IntlShape) => {
	const s = FormSchema
	return FormSchema.extend({
		uuid: s.shape.id.optional(),
	})
}

export const basicInformationFormSchema = (intl: IntlShape) =>
	createFormSchemaLocalized(intl).pick({
		id: true,
	})

export const tableFormSchema = (intl: IntlShape) =>
	createFormSchemaLocalized(intl).pick({
		id: true,
	})
